import * as React from 'react';
import { GridContainer } from './container';
import { Grid } from './grid';
export const ContainedGrid = ({ type, className, ...other }) => (React.createElement(GridContainer, { ...{ className, type } },
    React.createElement(Grid, { ...other })));
ContainedGrid.displayName = 'ContainedGrid';
//# sourceMappingURL=contained-grid.js.map